import { authRouteMiddleware } from '@/middlewares/auth-middleware';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/settings')({
  component: Outlet,
  server: {
    middleware: [authRouteMiddleware],
  },
});
